// DEPRECATE THIS - @theamanbhargava

const openInNewTab = (url) => window.open(url, "_blank")
export default openInNewTab;
